import { put, takeLatest, delay } from "redux-saga/effects";
import { getCampaignDetailApi } from "store/api/SpecialOfferApi";
import { GET_CAMPAIGN_DETAIL_ACTION } from "../../actions/SpecialOfferPageAction/actionTypes";

import * as specialOfferPageAction from "../../actions/SpecialOfferPageAction";
import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* getCampaignDetail(action) {
	yield put(globalAction.openLoadingPage());
	const res = yield getCampaignDetailApi(action.params);
	try {
		if (res?.code === 0) {
			yield put(
				specialOfferPageAction.setCampaignDetailAction(res?.data)
			);
		} else {
			yield errorMessage(res?.message);
		}
		yield delay(500);
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* getCampaignDetailSaga() {
	yield takeLatest(GET_CAMPAIGN_DETAIL_ACTION, getCampaignDetail);
}

export default getCampaignDetailSaga;
